import React, { useEffect, useState } from "react";
import AOS from "aos";
import GetQuoteComponent from "../GetQuote";
import imgIcon1 from "../../../../../assets/images/d1.svg";
import imgIcon2 from "../../../../../assets/images/d2.svg";
import imgIcon3 from "../../../../../assets/images/d3.svg";
import DigitalSupplier from "../../../../../assets/images/1Palle.jpeg";
// import DigitalSupplier from "../../../../../assets/images/DigitalSupplie.svg";
import ButtonGroup from "../../ButtonGroup";
import { Collapse } from "react-collapse";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { NavLink, useHistory } from "react-router-dom";
import {
  Container,
  Wrapper,
} from "web/pages/public/landing-page/StartPage/LandingPage/LandingPageStyled";

function CollapsibleList({ items }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleCollapse = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}>
          <div className="list-box">
            <span>{item.title}</span>
            {/* <button onClick={() => toggleCollapse(index)}>
              {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </button> */}
            {/* <Collapse isOpened={openIndex === index}> */}
            <div className="collapsible-content">
              <p>{item.content}</p>
            </div>
            {/* </Collapse> */}
          </div>
        </li>
      ))}
    </ul>
  );
}

const LandingPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
      once: true,
    });
  }, []);

  const items = [
    {
      title: "On Demand Buy/Sell",
      content:
        "Instantly access and buy or sell pallets to meet your immediate needs",
    },
    {
      title: "Flexible Pricing",
      content:
        "Benefit from both short and long-term pricing strategies tailored to your budget.",
    },
    {
      title: "Market Intelligence",
      content: "Utilize real-time data to make informed procurement decisions.",
    },
    {
      title: "Continuous Improvement",
      content:
        "Enhance efficiency through market intelligence and ongoing optimization.",
    },
  ];

  const items1 = [
    {
      title: "Vetted Supplier Network",
      content:
        "Access a wide network of thoroughly vetted suppliers for reliable sourcing.",
    },
    {
      title: "Quality Assurance",
      content:
        "Ensure high standards with our dedicated quality assurance team.",
    },
    {
      title: "Capacity Management",
      content:
        "Optimize your supply chain with robust capacity planning and management.",
    },
    {
      title: "Flexible Logistics",
      content:
        "Enjoy adaptable logistics and scheduling to meet your dynamic requirements.",
    },
  ];
  const items2 = [
    {
      title: "Centralized Console",
      content:
        "Manage your entire process, from order to proof of delivery, in one place.",
    },
    {
      title: "Network Visibility",
      content:
        "Gain full visibility across your entire supply chain network, one site to national networks.",
    },
    {
      title: "KPI Dashboard",
      content:
        "Track performance and metrics with our comprehensive KPI dashboard and reporting.",
    },
    {
      title: "Streamlined Transactions",
      content:
        "Simplify buying, selling, and returns with a centralized system.",
    },
  ];

  return (
    <Container>
      <Wrapper>
        <section className="banner">
          <div className="quote">
            <GetQuoteComponent />
          </div>
          {/* <div className="quote search_inventory">
            <button>SEARCH INVENTORY</button>
          </div> */}

          <div
            className="banner-text"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            <div className="text-wrp" data-aos="fade-up" data-aos-delay="800">
              <div className="need">
              <h1>Pallet Solutions for Every Need. </h1>
              <h2 className="mb-4">This is 21st Century Procurement.</h2>
              </div>
              <p>PalletTrader is the leading digital pallet </p>
              <p>marketplace and order management console </p>
              <p>designed to meet the needs of the pallet industry.</p>
            </div>
          </div>
        </section>
        <section className="simplify_process">
          <div className="simplify_process_titel">
            <div>
              <h2>Simplify Your Process. Increase Your Efficiency.</h2>
              <h2> Unlock Endless Benefits.</h2>
            </div>
          </div>
          <div className="box-3-wrp">
            <div className="box-info">
              <div className="text-bg">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h4>Cost Optimization</h4>
                  <CollapsibleList items={items} />
                </div>
              </div>
              {/* <div className="img-bg">
                <img src={imgIcon1} />
              </div> */}
            </div>
            <div className="box-info">
              <div className="text-bg">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h4>Supply Assurance</h4>
                  <CollapsibleList items={items1} />
                </div>
              </div>
              {/* <div className="img-bg">
                <img src={imgIcon2} />
              </div> */}
            </div>
            <div className="box-info">
              <div className="text-bg">
                <div data-aos="fade-up" data-aos-delay="100">
                  <h4>Order Management</h4>
                  <CollapsibleList items={items2} />
                </div>
              </div>
              {/* <div className="img-bg">
                <img src={imgIcon3} />
              </div> */}
            </div>
          </div>
          {/* <div className="item-center-box">
            <button>LEARN MORE</button>
          </div> */}
        </section>
        <section className="our_expertise">
          <div className="expertise_overlay">
            <div data-aos="fade-right" data-aos-delay="100">
              <h2>Your Needs. Our Expertise.</h2>
              <h2>Solutions That Work.</h2>
              <p className="max-w">
                We understand that every business has different pallet
                management needs. That’s why we offer a range of services from
                self service to fully managed solutions.
              </p>
              <div className="grid">
                <button>
                  <NavLink to="/self-managed-services">
                    {" "}
                    TAKE ME TO SELF SERVICE
                  </NavLink>
                </button>
                <button>
                  <NavLink to="/managed-services">
                    TAKE ME TO MANAGED SERVICES
                  </NavLink>
                </button>
                <button>
                  <NavLink to="/customized-pallet-solutions">
                    TAKE ME TO CUSTOM SOLUTIONS
                  </NavLink>
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="digital_supplier">
          <div className="digital_supplier_img">
            <img
              src={DigitalSupplier}
              alt="icon"
              data-aos="fade-down"
              data-aos-delay="100"
            />
          </div>
          <div className="digital_supplier-text">
            <div data-aos="fade-up" data-aos-delay="100">
              <h2>Built Around the Largest Digital Supplier Network.</h2>
              <p>
                Leverage the power of PalletTrader’s extensive digital pallet
                supplier network to streamline your pallet procurement process.
                Our platform connects you to a wide selection of trusted
                suppliers, ensuring you have access to high quality pallets
                wherever and whenever you need them.
              </p>
              {/* <button>MORE ABOUT THE NETWORK</button> */}
            </div>
          </div>
        </section>

        <section className="our_expertise suppliers mb-0">
          <div className="expertise_overlay expert">
            <div data-aos="fade-right" data-aos-delay="100">
              <h2>Created for Suppliers and</h2>
              <h2>Buyers. Unifying Networks.</h2>
              <p className="max-w">
                PalletTrader offers robust tools and features that facilitate
                seamless transactions, ensuring efficiency and transparency in
                every interaction.
              </p>
              <div className="grid">
                <button>
                  <NavLink to="/pallet-buyer-solutions">
                    TAKE ME TO BUYER SOLUTIONS
                  </NavLink>
                </button>
                <button>
                  <NavLink to="/pallet-supplier-and-broker-solutions">
                    TAKE ME TO SUPPLIER SOLUTIONS
                  </NavLink>
                </button>
              </div>
            </div>
          </div>
        </section>
        <section
          className="search_marketplace"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h2>Search the Marketplace. Request a Quote. </h2>
          <h2>Experience Innovation.</h2>
          <div className="experience">
            <ButtonGroup />
          </div>
        </section>
      </Wrapper>
    </Container>
  );
};

export default LandingPage;
